import React from 'react';
import { Button, notification, Form, type FormProps, Input, Card, Select, InputNumber, Table } from 'antd';
import { AffiliateService } from "./../../../services/AffiliateService";
import { DatePickerProps } from 'antd/lib';
import { RangePickerProps } from 'antd/es/date-picker';


interface Props {
    record: any
    onFinish: () => void
}

export default function Create(props: Props) {

    const [form] = Form.useForm();
    const [isTopAgent, setIsTopAgent] = React.useState<number>(0)
    const [subAgents, setSubAgents] = React.useState<Array<any>>([])
    const [commissionRatePercent, setCommissionRatePercent] = React.useState<number | null>(0)


    React.useEffect(() => {

      
        const record = props?.record
        form.resetFields();
        form.setFieldsValue({
            is_top_agent: record?.is_top_agent,
            company_name: record?.company_name,
            top_agent_id: record?.top_agent_id,
            commission_rate: record?.commission_rate || 0
        })
        setIsTopAgent(record?.is_top_agent)
        setCommissionRatePercent(props?.record?.commission_rate)


        getMember(props?.record?.id);

    }, [props?.record?.id])

    const getMember = async (id: number) => {
        const res = await AffiliateService.getAffiliateMember(id);
        if (res?.status == 1) {

            const { subAgents } = res.data;
            setSubAgents(subAgents)
        }
    }

    const onFinish: FormProps["onFinish"] = async (values) => {

        const formData = new FormData();
        formData.append('is_top_agent', values.is_top_agent ? "1" : "0");
        formData.append('top_agent_id', values.top_agent_id ? values.top_agent_id : '0');
        if (values.is_top_agent == 1) {
            formData.append('company_name', values.company_name);
        } else {
            formData.append('commission_rate', values.commission_rate);
        }




        if (props?.record?.id) {
            var res = await AffiliateService.updateAffiliateMember(formData, props.record.id)
        } else {

            form.resetFields();
        }

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            if (!props?.record?.id) {
                form.resetFields();
            }
            props.onFinish();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const onOk = (value: DatePickerProps['value'] | RangePickerProps['value']) => {
        console.log('onOk: ', value);
        form.setFieldValue('expired_date', value)
    };


    const handleChange = (value: number) => {
        console.log(`selected ${value}`);
        setIsTopAgent(value)
    };

    return (
        <Card
            bordered={false}>

            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 800 }}
                initialValues={{
                    is_top_agent: 0,
                    top_agent_id: '',
                    company_name: '',
                    commission_rate: 0
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >

                <Form.Item
                    label="Agent Type"
                    name="is_top_agent"
                    rules={[{ required: true, message: 'Please select top agent' }]}
                >
                    <Select
                        style={{ width: 120 }}
                        onChange={handleChange}
                        options={[
                            { value: 0, label: 'Agent' },
                            { value: 1, label: 'Top Agent' },
                        ]}
                    />
                </Form.Item>


                {
                    isTopAgent == 1 ?
                        <>
                            <Form.Item
                                label="Company Name"
                                name="company_name"
                                rules={[{ required: true, message: 'Please fill company name' }]}
                            >
                                <Input />
                            </Form.Item>

                        </>
                        :

                        <>
                            <Form.Item
                                label="Top Agent Id"
                                name="top_agent_id"
                                rules={[{ required: false, message: 'Please fill top agent id' }]}
                            >
                                <InputNumber min={0} />
                            </Form.Item>
                            <Form.Item
                                label="Commission Rate"
                                name="commission_rate"
                                rules={[{ required: true, message: 'Please fill commission rate ex. 0.5' }]}
                                extra={`${(commissionRatePercent || 0) * 100} %`}
                            >
                                <InputNumber
                                    min={0}
                                    max={1}
                                    onChange={(text) => {
                                        setCommissionRatePercent(text)
                                    }}
                                />
                            </Form.Item>
                        </>
                }





                {/* 

                <Form.Item
                    label="Limit"
                    name="limit"
                    rules={[{ required: true, message: 'Please fill limit name' }]}
                >
                    <InputNumber min={1} max={1000000} />
                </Form.Item> */}

                {/* 
                <Form.Item
                    label="Expired Date"
                    name="expired_date"
                    rules={[{ required: true, message: 'Please field expired date' }]}
                >
                    <DatePicker
                        showTime
                        format={'YYYY-MM-DD HH:mm:ss'}
                        onChange={(value, dateString) => {
                            console.log('Selected Time: ', value);
                            console.log('Formatted Selected Time: ', dateString);
                        }}
                        onOk={onOk}
                    />

                </Form.Item> */}


                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        {props.record?.id ? 'อัพเดต' : 'บันทึก'}
                    </Button>
                </Form.Item>



            </Form>


            {
                isTopAgent ?
                    <Card title="Agents">
                        <Table
                            scroll={{ x: 400 }}
                            columns={[
                                {
                                    title: 'User Id',
                                    dataIndex: 'user_id',
                                    key: 'user_id',
                                },
                                {
                                    title: 'Fullname',
                                    dataIndex: 'full_name',
                                    key: 'full_name',
                                },
                                {
                                    title: 'Email',
                                    dataIndex: 'email',
                                    key: 'email',
                                },
                                {
                                    title: 'Tel',
                                    dataIndex: 'tel',
                                    key: 'tel',
                                },
                                {
                                    title: 'Commission Rate',
                                    dataIndex: 'commission_rate',
                                    key: 'commission_rate',
                                },
                            ]}
                            dataSource={subAgents}
                            pagination={false}
                        >

                        </Table>
                    </Card>
                    :
                    null
            }
        </Card>
    )
}
